import React from "react";
import { Link } from "react-router-dom";

const Cancellation = () => {
  return (
    <>
      <section className="pt-[180px] max-md:pt-[130px] pb-[80px] relative max-lg:bg-[right_center] bg-[#f4f4f4] about-banner overflow-hidden">
        <div className="container">
          <div className="row items-center">
            <div className="w-full">
              <div className="relative max-md:text-center">
                <h2 className="text-[92px] max-md:text-[50px] font-bold capitalize font-sora text-secondary leading-[1.2]">
                  Cancellation Policy
                </h2>
                <img
                  src="assets/img/shap-three-1.png"
                  alt="banner-shap"
                  className="absolute w-46 w-35 -top-[30px] -left-[32px] max-md:hidden  animate-topshap"
                />
              </div>
              <ol className="mb-[16px] flex items-center max-md:justify-center max-md:mb-[40px] pt-[20px] max-md:hidden">
                <li className="text-[22px] text-secondary font-sora capitalize">
                  <Link to="/"> Home </Link>
                </li>
                <li
                  className="text-[22px] text-gary capitalize before:content-['-'] before:float-left before:text-gary before:px-[10px]"
                  aria-current="page"
                >
                  Cancellation Policy
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section id="h4-pricing" className="relative w-full overflow-hidden">
        <div className="w-full h4-pricing-wrapper max-md:px-[30px] pb-[80px] md:pb-[80px] max-md:pt-[60px] md:pt-[80px] pricing_section_bg">
          <div className="theme-container mx-auto">
            <div className="w-full">
              <div className="container">
                <div className="services-details-items">
                  <div className="row">
                    <div className="col-xl-12 services-single-content">
                      <p>
                        We believes in helping its customers as far as possible,
                        and has therefore a liberal cancellation policy. Under
                        this policy:
                      </p>
                      <ul>
                        <li>
                          1. Cancellations will be considered only if the request
                          is made within 7 days of placing the order. However, the
                          cancellation request may not be entertained if the
                          orders have been communicated to the vendors/merchants
                          and they have initiated the process of shipping them.
                        </li>
                        <li>
                          2. We does not accept cancellation requests for orders
                          already initiated or in transit or completed. However,
                          refund/replacement can be made if the customer
                          establishes that the quality of product/service
                          delivered is not good.
                        </li>
                        <li>
                          3. In case of improper delivery of services or
                          inaccurate results, please report the same to our
                          Customer Service team. The request will, however, be
                          entertained once the health provider has checked and
                          determined the same at his own end. This should be
                          reported within 7 days of receipt of the
                          product/service.
                        </li>
                        <li>
                          4. In case you feel that the product/service received is
                          not as promised by us or as per your expectations, you
                          must bring it to the notice of our customer service
                          within 7 days of receiving the product/service. The
                          Customer Service Team after looking into your complaint
                          will take an appropriate decision.
                        </li>
                        <li>
                          5. In case of any Refunds approved by us, it’ll take 6-8
                          days for the refund to be processed to the end customer.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="shape-1 absolute left-40 top-96 z-10">
            <img src="assets/images/home-four/shape-1.webp" alt="" />
          </div>
          <div className="shape-2 absolute right-96 top-96 z-10">
            <img src="assets/images/home-four/shape-2.webp" alt="" />
          </div>
          <div className="shape-3 absolute left-96 top-[550px] z-10">
            <img src="assets/images/home-four/shape-3.webp" alt="" />
          </div>
          <div className="shape-4 absolute right-96 top-[550px] z-10">
            <img src="assets/images/home-four/shape-4.webp" alt="" />
          </div>
        </div>
      </section>

    </>
  );
};

export default Cancellation;
